import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { MoneyDisplay } from '../../order-selection/starter-kit-selection/util-starter-kit/MoneyDisplay';

interface Props {
  price: number;
  label: string;
}

export const ListPrice = observer<Props>(({ price, label }) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex">
      <span className="mr-auto">{t(label)}</span>
      <span className="">
        <MoneyDisplay price={price} />
      </span>
    </div>
  );
});
